import { formatDay } from '@/shared/lib/format';
import { dayParts } from '@/shared/lib/time-zone';

import type { ReportGrouping } from '../types/report.types';

export const GROUPING_LABEL: Record<ReportGrouping, string> = {
  day: 'Day',
  month: 'Month',
  country: 'Country',
  channel: 'Payment channel',
  provider: 'Provider',
  brand: 'Brand',
  denomination: 'Denomination',
};

export const GROUPINGS = Object.keys(GROUPING_LABEL) as ReportGrouping[];

export const isTimeGrouping = (grouping: ReportGrouping) =>
  grouping === 'day' || grouping === 'month';

/**
 * A day (yyyy-MM-dd) or month (yyyy-MM) key as a short axis label: "4 Oct" / "Oct 2026". Keys are
 * market days from the server, shown as written.
 */
export function formatPeriodKey(key: string, long = false): string {
  const day = key.length === 7 ? `${key}-01` : key;
  if (!dayParts(day)) return key;
  if (key.length === 7) return formatDay(day, 'MMM yyyy');
  return formatDay(day, long ? 'd MMM yyyy' : 'd MMM');
}
